import { ReactNode, /*useEffect,*/ useReducer } from "react";
import { LayoutContext } from "./LayoutContext";
import { LayoutContextType, LayoutActions, LayoutContextActionType } from "./LayoutContextTypes";

const reducer = (state: LayoutContextType, action: LayoutActions): LayoutContextType => {
    switch (action.type) {
        case LayoutContextActionType.ScrollTargetSet:
            return {
                ...state,
                scrollTarget: action.scrollTarget
            };

        case LayoutContextActionType.SwipeChanged:

            // how to ensure only one action executed
            return {
                ...state,
                swipeAction: action.payload
            };

        case LayoutContextActionType.ViewAllChanged:
            return {
                ...state,
                viewAll: action.payload
            };

        default:
            return state;
    }
};

export type LayoutContextProviderProps = {
    children: ReactNode;
};

const defaultLayoutContext: LayoutContextType = { 
    scrollTarget: undefined,
    swipeAction: undefined,
    viewAll: false
 };

export function LayoutContextProvider({ children }: LayoutContextProviderProps) {
    
    // console.log("========== Rendering ContentLayoutContextProvider ==========");

    const [state, dispatch] = useReducer(reducer, defaultLayoutContext);

    return (
        <LayoutContext.Provider value={[state, dispatch]}>
            {children}
        </LayoutContext.Provider>
    );
}